import { PureComponent } from 'react';

interface Props {
    text: string;
    count: string;
    className?: string;
    showBorder?: boolean;
}

class CountContainer extends PureComponent<Props> {
    render() {
        const { text, count, className, showBorder } = this.props;

        return (
            <div className="flex items-center space-x-16">
                {showBorder && <div className="bg-darwin-neutral_new-200 w-1 h-36"></div>}
                <div className="space-y-4">
                    <p className="uppercase">{text}</p>
                    <p
                        className={`text-darwin-neutrals-1000 text-16 font-700 ${
                            className ? className : ''
                        }`}
                    >
                        {count}
                    </p>
                </div>
            </div>
        );
    }
}

export default CountContainer;
